import React from "react";
import { Alert } from "@mui/material";

const NotFound = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Alert severity="error" className="mb-4">
        Client and Connection should be selected.
      </Alert>
    </div>
  );
};

export default NotFound;